'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _lodash = require('lodash');
var _BazaarVoiceModal = require('../bazaarvoice/BazaarVoiceModal');
var _BazaarVoiceModal2 = _interopRequireDefault(_BazaarVoiceModal);
var _ProductSlide = require('./ProductSlide');
var _ProductSlide2 = _interopRequireDefault(_ProductSlide);
var _ProductCard = require('../productCard/ProductCard');
var _ProductCard2 = _interopRequireDefault(_ProductCard);
var _CarouselDots = require('../carousel/CarouselDots');
var _CarouselDots2 = _interopRequireDefault(_CarouselDots);
var _slider = require('../utility/helpers/slider');
var _slider2 = _interopRequireDefault(_slider);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ProductsCarousel = function (_React$Component) {
  _inherits(ProductsCarousel, _React$Component);
  function ProductsCarousel(props) {
    _classCallCheck(this, ProductsCarousel);
    var _this = _possibleConstructorReturn(this, (ProductsCarousel.__proto__ || Object.getPrototypeOf(ProductsCarousel)).call(this, props));
    _this.state = {
      activeProduct: null,
      activeIndex: -1
    };
    _this.handleToggleClick = _this.handleToggleClick.bind(_this);
    _this.handleDotClick = _this.handleDotClick.bind(_this);
    _this.handleCloseClick = _this.handleCloseClick.bind(_this);
    return _this;
  }
  _createClass(ProductsCarousel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.activeProduct) {
        this.updateActiveProduct(this.props.activeProduct, this.getIndex(this.props.activeProduct));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;
      var sliderSettings = this.props.sliderSettings;
      // Do not want to override in this component

      sliderSettings.customClickEvent = true;
      sliderSettings.handleSlideUpdate = function (slider) {
        return _this2.handleSlideUpdate(slider);
      };
      var componentSettings = {
        responsive: {
          breakpoint: 768,
          disableDrag: true
        }
      };
      var settings = (0, _lodash.defaultsDeep)(sliderSettings, componentSettings);
      var activeNode = void 0;
      if (this.state.activeProduct) {
        activeNode = this.track.childNodes[this.state.activeIndex];
      } else {
        activeNode = null;
      }
      this.productsSlider = new _slider2.default(this.track, settings, activeNode);
    }
  }, {
    key: 'getIndex',
    value: function getIndex(slug) {
      return (0, _lodash.findIndex)(this.props.products, function (p) {
        return p.slug === slug;
      });
    }
  }, {
    key: 'handleSlideUpdate',
    value: function handleSlideUpdate(slider) {
      var _this3 = this;
      if (slider.state.activeSlide !== null) {
        var slug = slider.state.activeSlide.id;
        this.updateActiveProduct(slug, this.getIndex(slug));
      } else {
        this.updateActiveProduct(null, -1);
      }
      setTimeout(function () {
        _this3.props.onSlideUpdate(_this3);
      }, 0);
    }
  }, {
    key: 'handleToggleClick',
    value: function handleToggleClick(slide, product, track) {
      var _this4 = this;
      var centerEl = void 0;
      if (this.state.activeProduct !== product.slug) {
        this.setState({
          activeProduct: product.slug
        });
        this.productsSlider.updateActiveSlide(slide);
        centerEl = slide;
      } else {
        this.setState({
          activeProduct: null
        });
        this.productsSlider.updateActiveSlide(null);
        centerEl = track;
      }
      var awaitTransitionEnd = function awaitTransitionEnd(e) {
        if (e.propertyName === 'width') {
          var centerPromise = new Promise(function (resolve) {
            setTimeout(function () {
              _this4.productsSlider.centerElement(centerEl);
            }, 0);
            resolve();
          });
          centerPromise.then(function () {
            centerEl.removeEventListener('transitionend', awaitTransitionEnd);
          });
        }
      };
      if (this.props.sliderSettings.responsive.breakpoint) {
        if (window.innerWidth < this.props.sliderSettings.responsive.breakpoint) {
          centerEl = this.productsSlider.getCenterElement();
          this.productsSlider.centerElement(centerEl);
        } else {
          centerEl.addEventListener('transitionend', awaitTransitionEnd);
        }
      } else {
        centerEl = this.productsSlider.getCenterElement();
        this.productsSlider.centerElement(centerEl);
      }
    }
  }, {
    key: 'handleCloseClick',
    value: function handleCloseClick() {
      this.setState({
        activeProduct: null
      });
      this.productsSlider.updateActiveSlide(null);
      this.productsSlider.centerElement(this.productsSlider.getCenterElement());
    }
  }, {
    key: 'handleDotClick',
    value: function handleDotClick(index) {
      if (this.state.activeIndex !== index) {
        this.productsSlider.onDotClick(index);
      }
    }
  }, {
    key: 'updateActiveProduct',
    value: function updateActiveProduct(slug, index) {
      this.setState({
        activeProduct: slug
      });
      this.setState({
        activeIndex: index
      });
      this.props.onSlideUpdate(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;
      return _react2.default.createElement('div', null, _react2.default.createElement('div', {
        className: 'products-carousel ' + this.props.className
      }, _react2.default.createElement('div', {
        className: 'products-carousel__track',
        ref: function ref(track) {
          _this5.track = track;
        }
      }, this.props.products.map(function (product) {
        return _react2.default.createElement(_ProductSlide2.default, {
          active: _this5.state.activeProduct === product.slug,
          bazaarVoiceEnabled: _this5.props.bazaarVoiceEnabled,
          key: 'product-' + product.slug,
          nutritionFacts: _this5.props.nutritionFacts,
          onToggleClick: function onToggleClick(slide) {
            _this5.handleToggleClick(slide, product, _this5.track);
          },
          product: product,
          social: _this5.props.social,
          socialEnabled: _this5.props.socialEnabled
        });
      })), _react2.default.createElement(_CarouselDots2.default, {
        activeIndex: this.state.activeIndex,
        className: 'products-carousel__nav',
        items: this.props.products,
        onClick: this.handleDotClick
      })), this.state.activeProduct ? _react2.default.createElement(_ProductCard2.default, {
        active: true,
        bazaarVoiceEnabled: this.props.bazaarVoiceEnabled,
        className: 'products-carousel__card visible-xs',
        nutritionFacts: this.props.nutritionFacts,
        onCloseClick: this.handleCloseClick,
        onToggleClick: this.handleCloseClick,
        product: this.props.products.filter(function (product) {
          return _this5.state.activeProduct === product.slug;
        }).shift(),
        social: this.props.social,
        socialEnabled: this.props.socialEnabled
      }) : null, _react2.default.createElement(_BazaarVoiceModal2.default, null));
    }
  }]);
  return ProductsCarousel;
}(_react2.default.Component);
ProductsCarousel.defaultProps = {
  activeProduct: '',
  bazaarVoiceEnabled: true,
  className: '',
  nutritionFacts: {},
  onSlideUpdate: function onSlideUpdate() {
    return false;
  },
  sliderSettings: {},
  social: {},
  socialEnabled: true
};
ProductsCarousel.propTypes = {
  activeProduct: _propTypes2.default.string,
  bazaarVoiceEnabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  nutritionFacts: _propTypes2.default.shape({
    calorieSource: _propTypes2.default.string,
    dailyValue: _propTypes2.default.string,
    disclaimer: _propTypes2.default.string,
    factPunctuation: _propTypes2.default.string,
    ingredientsTitle: _propTypes2.default.string,
    perServing: _propTypes2.default.string,
    servingSize: _propTypes2.default.string,
    threeColumn: _propTypes2.default.bool
  }),
  onSlideUpdate: _propTypes2.default.func,
  products: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    brand_code: _propTypes2.default.string,
    description: _propTypes2.default.string,
    image: _propTypes2.default.shape({
      src: _propTypes2.default.string,
      alt: _propTypes2.default.string,
      type: _propTypes2.default.string
    }),
    ingredient: _propTypes2.default.array,
    name: _propTypes2.default.string,
    nutrition: _propTypes2.default.shape({}),
    product_info: _propTypes2.default.shape({
      serving_size: _propTypes2.default.string,
      serving_units_code: _propTypes2.default.string
    }),
    slug: _propTypes2.default.string,
    social: _propTypes2.default.shape({
      email: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        subject: _propTypes2.default.string,
        message: _propTypes2.default.string
      }),
      facebook: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string,
        subject: _propTypes2.default.string,
        image: _propTypes2.default.string
      }),
      pinterest: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string,
        image: _propTypes2.default.string
      }),
      twitter: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        message: _propTypes2.default.string
      })
    })
  })).isRequired,
  sliderSettings: _propTypes2.default.shape({
    customClickEvent: _propTypes2.default.bool,
    disableDrag: _propTypes2.default.bool,
    dots: _propTypes2.default.bool,
    initialSlide: _propTypes2.default.number,
    toggleSlideClick: _propTypes2.default.bool,
    responsive: _propTypes2.default.shape({
      breakpoint: _propTypes2.default.number,
      disableCenter: _propTypes2.default.bool,
      disableDrag: _propTypes2.default.bool
    })
  }),
  social: _propTypes2.default.shape({
    emailSubject: _propTypes2.default.string,
    emailMessage: _propTypes2.default.string,
    emailUrl: _propTypes2.default.string,
    facebookAppId: _propTypes2.default.string,
    facebookIcon: _propTypes2.default.oneOf(['default', 'square']),
    facebookImage: _propTypes2.default.string,
    facebookMessage: _propTypes2.default.string,
    facebookSubject: _propTypes2.default.string,
    facebookUrl: _propTypes2.default.string,
    pinterestIcon: _propTypes2.default.oneOf(['default', 'p', 'square']),
    pinterestImage: _propTypes2.default.string,
    pinterestMessage: _propTypes2.default.string,
    pinterestUrl: _propTypes2.default.string,
    twitterIcon: _propTypes2.default.oneOf(['default', 'square']),
    twitterMessage: _propTypes2.default.string,
    twitterUrl: _propTypes2.default.string,
    services: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['email', 'facebook', 'pinterest', 'print', 'twitter']))
  }),
  socialEnabled: _propTypes2.default.bool
};
exports.default = ProductsCarousel;